/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Startup_P1dInputs */

const en_mk_sol_startup_p1d = /** @type {(inputs: Mk_Sol_Startup_P1dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Writing specs, tidying meeting notes, answering the same question again — all necessary, none of it moves the product forward.`)
};

const id_mk_sol_startup_p1d = /** @type {(inputs: Mk_Sol_Startup_P1dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menulis spesifikasi, merapikan catatan rapat, menjawab pertanyaan berulang — semuanya perlu, tidak satupun memajukan produk.`)
};

/**
* | output |
* | --- |
* | "Writing specs, tidying meeting notes, answering the same question again — all necessary, none of it moves the product forward." |
*
* @param {Mk_Sol_Startup_P1dInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_startup_p1d = /** @type {((inputs?: Mk_Sol_Startup_P1dInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Startup_P1dInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_startup_p1d(inputs)
	return en_mk_sol_startup_p1d(inputs)
});